import { FC } from "react";
import styles from "./Button.module.css";
import { Spinner } from "../icons";

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  text: string;
  isLoading?: boolean;
  icon?: React.ReactNode;
  href?: string;
  target?: string;
  rel?: string;
}

export const Button: FC<ButtonProps> = ({
  text,
  className,
  isLoading,
  disabled,
  icon,
  href,
  target,
  rel,
  ...props
}) => {
  const content = (
    <span className={styles.buttonContent}>
      {icon && <span className={styles.buttonIcon}>{icon}</span>}
      <span className={styles.buttonText}>{text}</span>
      {isLoading && <Spinner size={14} className={styles.buttonSpinner} />}
    </span>
  );

  if (href) {
    return (
      <a
        href={href}
        target={target}
        rel={rel}
        className={`${styles.button} ${isLoading ? styles.loading : ""} ${
          className ?? ""
        }`}
        {...(props as any)}
      >
        {content}
      </a>
    );
  }

  return (
    <button
      className={`${styles.button} ${isLoading ? styles.loading : ""} ${
        className ?? ""
      }`}
      disabled={disabled || isLoading}
      {...props}
    >
      {content}
    </button>
  );
};
